import { FunctionComponent } from 'react';
import { Box, H2, Text, VStack } from '@montel/montelpro-shared-components-v2';
import BackButton from 'components/common/BackButton/BackButton';
import { getParsedApiError } from '../ApiErrorDescription/getParsedApiError';

export interface NotFoundProps {
	title?: string;
	message?: string;
	error?: any;
	showBackButton?: boolean;
	children?: React.ReactNode;
}

export const NotFound: FunctionComponent<NotFoundProps> = ({
	title = '404 - Not Found',
	message,
	error,
	showBackButton = true,
	children,
}) => {
	const displayMessage =
		message ||
		getParsedApiError(error)?.details ||
		'The requested resource could not be found.';

	return (
		<Box bg="bgMainContainer">
			{showBackButton && <BackButton />}
			<Box
				minH="400px"
				display="flex"
				alignItems="center"
				justifyContent="center"
			>
				<VStack gap="xl" align="center">
					<H2>{title}</H2>
					<Text color="textSecondary" textAlign="center">
						{displayMessage}
					</Text>
				</VStack>
			</Box>
			{children}
		</Box>
	);
};

export default NotFound;
